import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * Effect that skips initial render
 */
export function useDidUpdateEffect(fn: EffectCallback, deps?: DependencyList) {
    const didMountRef = useRef(false);

    useEffect(() => {
        if (didMountRef.current) {
            return fn();
        }
        didMountRef.current = true;
    }, deps);
}
